var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.206 6.603A5.61 5.61 0 0 0 7.603 1 5.61 5.61 0 0 0 2 6.603a5.61 5.61 0 0 0 5.603 5.603c.87 0 1.709-.196 2.486-.584l.36-.18 2.376 3.368c.14.198.45.251.65.112a.46.46 0 0 0 .113-.649l-2.377-3.367.288-.278a5.56 5.56 0 0 0 1.709-4.022zm-5.603 4.67a4.673 4.673 0 0 1-4.67-4.67 4.673 4.673 0 0 1 4.67-4.67 4.673 4.673 0 0 1 4.67 4.67 4.673 4.673 0 0 1-4.67 4.67"
  })));
};
export default SvgSearch;